var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftBoxRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 82"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD715",
  d: "M68.354 52.382H15.021a3.333 3.333 0 0 0-3.334 3.333v20a3.333 3.333 0 0 0 3.334 3.334h53.333a3.333 3.333 0 0 0 3.334-3.334v-20a3.333 3.333 0 0 0-3.334-3.333"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M45.023 79.049V52.382h-6.666v26.667z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD715",
  d: "M56.054 12.615 9 36.353a3.333 3.333 0 0 0-1.475 4.477l2.676 5.305a3.333 3.333 0 0 0 4.477 1.474l47.055-23.737a3.333 3.333 0 0 0 1.474-4.478l-2.676-5.304a3.333 3.333 0 0 0-4.477-1.475"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "m42.116 33.761-5.678-11.256-7.816 3.942 5.679 11.257z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M6.795 23.075c-1.148-1.44-.463-3.475 1.181-4.304l2.725-1.375c7.96-4.015 17.682-.813 21.698 7.147l-5.701 2.876c-6.947 3.504-15.237 1.511-19.903-4.344"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "m38.054 21.697-5.7 2.876c-4.016-7.96-.814-17.682 7.146-21.698l2.725-1.374c1.643-.83 3.687-.171 4.163 1.607 1.936 7.233-1.387 15.085-8.334 18.59"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF7A14",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4.501,
  d: "M63.28 46.81c.31-.157 3.525-3.849 8.025-1.749"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0090FF",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4.501,
  d: "m59.716 34.829-2.981 6.736"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#56CEC2",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4.501,
  d: "M47.188 40.133s.685 2.758-.684 5.477"
})));
export default SvgGiftBoxRed;